/* @flow */

import * as React from 'react';
import {Title} from '../typography';
import {CloseButton, SaveButton, Button} from '../button';
import './popover-form.css';

type Props = {
    children: React.Node,
    width: number,
    height?: number,
    title: React.Node,
    onClose: () => void,
    onSubmit: () => void,
    saveButtonDisabled: boolean,
    isSaving: boolean,
    errorSaving?: boolean,
    onClearSaveComplete?: () => void,
    saveButtonText?: string,
    saveButtonSavingText?: string,
    saveButtonSuccessText?: string,
    cancelButtonText: string,
    allowTitleWrapping?: boolean,
    resetOnSaveComplete?: boolean,
    saveCompleteTimeout?: number,
};

PopoverForm.defaultProps = {
    width: 300,
    isSaving: false,
    saveButtonDisabled: false,
    cancelButtonText: 'Cancel',
};

export function PopoverForm(props: Props) {
    const onSubmit = (e: SyntheticFocusEvent<*>) => {
        e.preventDefault();
        props.onSubmit();
    };

    return (
        <div styleName='popover-form' style={{width: props.width, height: props.height}}>
            <div styleName='top'>
                <div styleName={props.allowTitleWrapping ? 'title' : 'title--no-wrap'}>
                    <Title>{props.title}</Title>
                </div>
                <CloseButton onClick={props.onClose} />
            </div>
            <form onSubmit={onSubmit}>
                <div styleName='form-body'>{props.children}</div>
                <div styleName='buttons'>
                    <Button variant='text' onClick={props.onClose} size='big'>
                        {props.cancelButtonText}
                    </Button>
                    <SaveButton
                        isSaving={props.isSaving}
                        buttonText={props.saveButtonText}
                        disabled={props.saveButtonDisabled}
                        savingText={props.saveButtonSavingText}
                        successText={props.saveButtonSuccessText}
                        onClearSaveComplete={props.onClearSaveComplete}
                        errorSaving={props.errorSaving}
                        resetOnComplete={props.resetOnSaveComplete}
                        saveCompleteTimeout={props.saveCompleteTimeout}
                    />
                </div>
            </form>
        </div>
    );
}
